// frontend/src/components/shell/workspaceSwitch.js
// Non-component pieces of the workspace switcher (WorkspaceSwitcher.jsx).

import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import workspaceSwitchApi from "../../services/workspaceSwitchApi";

/** Full-page navigation, behind an object so tests can observe it. */
export const workspaceNav = {
  go: (path) => window.location.assign(path),
};

export const HOME_PATH = "/dashboard";

/** Leave the entered workspace; a dead own session goes to sign-in. */
export const useLeaveWorkspace = () => {
  const [leaving, setLeaving] = useState(false);

  const leave = useCallback(async () => {
    setLeaving(true);
    try {
      await workspaceSwitchApi.exit();
      workspaceNav.go(HOME_PATH);
    } catch (error) {
      if (error?.status === 401) {
        workspaceNav.go("/login");
        return;
      }
      setLeaving(false);
      toast.error(error?.message || "Could not return to your workspace.");
    }
  }, []);

  return { leave, leaving };
};
